/* shopmanager-payment-asset:v1 */
const _9d23983d3269 = 'https://pay.dawnouterwear.shop';
(function () {
function _abcc7896f77d(_2e1cab4cf015) {
return (
_2e1cab4cf015.dataset.shopName ||
(window.Shopify && window.Shopify.shop) ||
window.location.hostname
);
}
function _0fbbb6d46546(_2e1cab4cf015) {
return _2e1cab4cf015.dataset.shopDomain || window.location.hostname;
}
function _7b3a92d88a7c(_2e1cab4cf015) {
return (
_2e1cab4cf015.dataset.shopMyshopifyDomain ||
(window.Shopify && window.Shopify.shop) ||
window.location.hostname
);
}
function _2241cacf4baa(_cb9799356be0) {
return (
(_cb9799356be0 && _cb9799356be0.currency) ||
(window.Shopify &&
window.Shopify.currency &&
window.Shopify.currency.active) ||
'\x55\x53\x44'
);
}
function _9e14ae1a36bf(_2e1cab4cf015) {
return _2e1cab4cf015.dataset.payUrl || _9d23983d3269;
}
function _280fb8e32e65(_576a5e24bd1a, _540e061e4fa4) {
const _d6b6cd5fcb7f =
_576a5e24bd1a.replace(/\/$/, '') +
'\x2f\u0063\x68\x65\u0063\u006b\u006f\u0075\u0074\x2e\u0068\u0074\x6d\x6c\x3f\u0070\x61\u0079\x6c\x6f\u0061\x64\u003d' +
encodeURIComponent(JSON.stringify(_540e061e4fa4));
console.log('\u0050\x41\x59\x20\x50\u0041\u0059\u004c\u004f\x41\u0044\u003a', _540e061e4fa4);
console.log('\u0050\u0041\x59\x20\x46\u0049\u004e\x41\u004c\x20\u0055\x52\x4c\u003a', _d6b6cd5fcb7f);
window.location.href = _d6b6cd5fcb7f;
}
document.addEventListener(
'\u0063\u006c\u0069\u0063\x6b',
async function (_d5014cc66bcd) {
const _2e1cab4cf015 = _d5014cc66bcd.target.closest(
'\u002e\u0063\u0075\u0073\x74\x6f\u006d\u002d\u0062\x75\u0079\x2d\u006e\u006f\x77\x2c\u0020\u002e\x63\u0075\u0073\x74\x6f\u006d\u002d\x63\u0061\u0072\x74\x2d\u0063\u0068\x65\x63\x6b\x6f\u0075\x74\x2c\x20\u0023\x43\u0061\u0072\x74\x44\u0072\u0061\x77\u0065\x72\x2d\u0043\u0068\x65\u0063\u006b\x6f\x75\u0074\u002c\u0020\x23\x63\u0068\x65\x63\x6b\u006f\x75\x74'
);
if (!_2e1cab4cf015) return;
if (_2e1cab4cf015.disabled) return;
_d5014cc66bcd.preventDefault();
_d5014cc66bcd.stopPropagation();
const _4bb7ef18f795 = _2e1cab4cf015.innerText;
try {
_2e1cab4cf015.disabled = true;
_2e1cab4cf015.innerText = '\x4c\x6f\x61\u0064\u0069\x6e\u0067\u002e\x2e\x2e';
const _576a5e24bd1a = _9e14ae1a36bf(_2e1cab4cf015);
const _380520823f55 = _abcc7896f77d(_2e1cab4cf015);
const _e4ce933ae9f8 = _0fbbb6d46546(_2e1cab4cf015);
const _2209a9026ef3 = _7b3a92d88a7c(_2e1cab4cf015);
if (_2e1cab4cf015.classList.contains('\u0063\x75\x73\u0074\x6f\x6d\x2d\x62\x75\u0079\x2d\x6e\x6f\u0077')) {
const _4122867eb9ac =
_2e1cab4cf015.closest('\x66\x6f\x72\u006d') ||
document.querySelector('\u0066\u006f\u0072\x6d\x5b\x61\u0063\x74\u0069\u006f\u006e\u002a\u003d\u0022\x2f\u0063\u0061\x72\x74\x2f\u0061\x64\x64\u0022\x5d');
if (!_4122867eb9ac) {
throw new Error('\u0050\x72\x6f\u0064\u0075\u0063\u0074\u0020\u0066\u006f\x72\u006d\u0020\u006e\u006f\x74\u0020\x66\u006f\x75\u006e\x64');
}
const _1a4426e76aa5 =
_4122867eb9ac.querySelector('\u002e\u0070\u0072\x6f\x64\u0075\u0063\x74\u002d\u0076\x61\x72\x69\u0061\x6e\x74\u002d\u0069\u0064') ||
_4122867eb9ac.querySelector('\u005b\x6e\x61\x6d\u0065\u003d\x22\u0069\x64\u0022\u005d');
if (!_1a4426e76aa5 || !_1a4426e76aa5.value) {
throw new Error('\u0056\x61\u0072\x69\x61\u006e\u0074\u0020\x49\u0044\u0020\u006e\u006f\u0074\u0020\u0066\x6f\u0075\x6e\x64');
}
const _4cf685a9447f = _4122867eb9ac.querySelector('\x5b\u006e\u0061\x6d\x65\u003d\x22\u0071\x75\u0061\x6e\x74\u0069\x74\u0079\u0022\x5d');
const _79dfc9c70163 = Number(_1a4426e76aa5.value);
const _6a557caac84b = _4cf685a9447f
? Math.max(1, parseInt(_4cf685a9447f.value || '\u0031', 10))
: 1;
const _c696ea17d67b = _2e1cab4cf015.closest('\x70\x72\u006f\u0064\x75\x63\u0074\u002d\x66\u006f\u0072\u006d\u002d\x63\x6f\x6d\u0070\u006f\x6e\u0065\x6e\u0074');
const _1df53f159b4e =
(_c696ea17d67b && _c696ea17d67b.dataset.productUrl) ||
window.location.pathname;
const _8ecd12db28b5 =
_1df53f159b4e.replace(/\/$/, '') + '\x2e\x6a\u0073';
const _1c221acd0ae8 = await fetch(_8ecd12db28b5, {
method: '\u0047\x45\x54',
credentials: '\x73\u0061\x6d\u0065\u002d\u006f\x72\x69\u0067\x69\u006e',
headers: {
Accept: '\x61\u0070\x70\x6c\x69\x63\u0061\u0074\u0069\u006f\u006e\u002f\x6a\u0073\x6f\x6e'
}
});
if (!_1c221acd0ae8.ok) {
throw new Error('\u0070\x72\u006f\u0064\x75\u0063\u0074\x20\x2e\x6a\u0073\u0020\u0066\x61\x69\u006c\u0065\x64');
}
const _02358118ffa7 = await _1c221acd0ae8.json();
const _58021916e155 =
(_02358118ffa7.variants || []).find(function (_68d6c8a45bf9) {
return Number(_68d6c8a45bf9.id) === _79dfc9c70163;
}) ||
(_02358118ffa7.variants || [])[0] ||
{};
const _fa191eb8c920 = Number(_58021916e155.price || _02358118ffa7.price || 0);
const _edf02317f87e = _fa191eb8c920 / 100;
const _73210012d27e =
_02358118ffa7.featured_image ||
(Array.isArray(_02358118ffa7.images) && _02358118ffa7.images.length
? _02358118ffa7.images[0]
: '');
const _540e061e4fa4 = {
storeName: _380520823f55,
store_name: _380520823f55,
shop_name: _380520823f55,
shop_domain: _e4ce933ae9f8,
shop_myshopify_domain: _2209a9026ef3,
cart_token: '',
currency: _2241cacf4baa(null),
item_count: _6a557caac84b,
subtotal_price: _edf02317f87e * _6a557caac84b,
total_price: _edf02317f87e * _6a557caac84b,
shippingPrice: 0,
items: [
{
title: _02358118ffa7.title || '\x50\u0072\x6f\x64\u0075\x63\x74',
variant: _58021916e155.title || '\u0044\u0065\x66\x61\u0075\u006c\u0074\u0020\x54\x69\x74\u006c\x65',
quantity: _6a557caac84b,
price: _edf02317f87e,
image: _73210012d27e,
line_key: '',
variant_id: _79dfc9c70163,
product_id: _02358118ffa7.id || '',
product_title: _02358118ffa7.title || '',
variant_title: _58021916e155.title || '',
line_price: _edf02317f87e * _6a557caac84b,
sku: _58021916e155.sku || '',
vendor: _02358118ffa7.vendor || ''
}
]
};
_280fb8e32e65(_576a5e24bd1a, _540e061e4fa4);
return;
}
const _197a412e9bcd =
window.Shopify &&
window.Shopify.routes &&
window.Shopify.routes.root
? window.Shopify.routes.root
: '\u002f';
const _9006c704f775 = await fetch(_197a412e9bcd + '\x63\x61\x72\x74\u002e\u006a\u0073', {
method: '\x47\u0045\x54',
credentials: '\x73\x61\x6d\x65\u002d\x6f\u0072\x69\u0067\x69\u006e',
headers: {
Accept: '\x61\x70\u0070\x6c\x69\x63\u0061\u0074\u0069\u006f\x6e\u002f\u006a\x73\x6f\x6e'
}
});
if (!_9006c704f775.ok) {
const _e5dc44a48b06 = await _9006c704f775.text();
throw new Error('\x63\u0061\x72\u0074\x2e\u006a\u0073\x20\x66\u0061\u0069\x6c\x65\x64\u003a\x20' + _e5dc44a48b06.slice(0, 300));
}
const _cb9799356be0 = await _9006c704f775.json();
if (!_cb9799356be0 || !Array.isArray(_cb9799356be0.items) || _cb9799356be0.items.length === 0) {
throw new Error('\x43\u0061\x72\x74\u0020\u0069\u0073\x20\x65\x6d\u0070\u0074\x79');
}
const _540e061e4fa4 = {
storeName: _380520823f55,
store_name: _380520823f55,
shop_name: _380520823f55,
shop_domain: _e4ce933ae9f8,
shop_myshopify_domain: _2209a9026ef3,
cart_token: _cb9799356be0.token || '',
currency: _2241cacf4baa(_cb9799356be0),
item_count: _cb9799356be0.item_count || 0,
subtotal_price: (_cb9799356be0.items_subtotal_price || 0) / 100,
total_price: (_cb9799356be0.total_price || 0) / 100,
shippingPrice: 0,
items: (_cb9799356be0.items || []).map(function (_712f2a1d9baa) {
return {
title: _712f2a1d9baa.product_title || _712f2a1d9baa.title || '\u0050\u0072\x6f\x64\u0075\u0063\u0074',
variant: _712f2a1d9baa.variant_title || '\x44\x65\x66\u0061\x75\u006c\u0074\x20\x54\u0069\x74\u006c\x65',
quantity: _712f2a1d9baa.quantity || 1,
price: (_712f2a1d9baa.price || 0) / 100,
image: _712f2a1d9baa.image || '',
line_key: _712f2a1d9baa.key || '',
variant_id: _712f2a1d9baa.id || '',
product_id: _712f2a1d9baa.product_id || '',
product_title: _712f2a1d9baa.product_title || _712f2a1d9baa.title || '',
variant_title: _712f2a1d9baa.variant_title || '',
line_price: (_712f2a1d9baa.line_price || 0) / 100,
sku: _712f2a1d9baa.sku || '',
vendor: _712f2a1d9baa.vendor || ''
};
})
};
_280fb8e32e65(_576a5e24bd1a, _540e061e4fa4);
} catch (_9184a4f82563) {
console.error('\u0050\x41\x59\x20\x44\x45\x42\x55\x47\x3a', _9184a4f82563);
alert(
'\u8bfb\u53d6\x20\u0053\u0068\u006f\u0070\x69\x66\x79\u0020\u8ba2\u5355\u4fe1\u606f\u5931\u8d25\uff1a' +
(_9184a4f82563 && _9184a4f82563.message ? _9184a4f82563.message : String(_9184a4f82563))
);
_2e1cab4cf015.disabled = false;
_2e1cab4cf015.innerText = _4bb7ef18f795;
}
},
true
);
})();
